// @flow

import { isOverflown } from '../classes/Helpers';
import { Component } from '../jsti/core';

export default class ExpandableProductBox extends Component {
  #title: HTMLElement;
  #activeClass: string = 'box--expandable';

  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setUp(pEl);

    if (isOverflown(this.#title)) {
      pEl.classList.add(this.#activeClass);
      pEl.style.minHeight = `${pEl.offsetHeight}px`;
    }
  }

  /**
   * Setup properties & validation
   */
  setUp(pEl: HTMLElement): void {
    const title: HTMLElement | null = pEl.querySelector('[ref="title"]');
    if (title) {
      this.#title = title;
    }

    if (!this.#title) {
      throw new Error('A product requires a title');
    }
  }
}
